export function isLocalhost(): boolean {
  return window.location.hostname === 'localhost';
}
